import type { FlowDSL } from '@holloway/dsl';
import { apiClient } from './api-client';

export const sessionsApi = {
  async createSession(flowSlug: string) {
    const { data } = await apiClient.post(`/run/${flowSlug}/session`);
    return data;
  },

  async advanceSession(sessionId: string, input?: any) {
    const { data } = await apiClient.post(`/run/session/${sessionId}/next`, { input });
    return data;
  },

  async backSession(sessionId: string, fromNodeId: string) {
    const { data } = await apiClient.post(`/run/session/${sessionId}/back`, { fromNodeId });
    return data;
  },

  async createPreviewSession(flow: any) {
    const { data } = await apiClient.post('/run/preview/session', { flow });
    return data;
  },

  // Preview is stateless on the server: each step carries the flow and the run
  // so far, and the response is the next run. Any API task can serve it.
  async stepPreview(
    flow: FlowDSL,
    run: {
      sessionId: string;
      state: Record<string, any>;
      currentNodeId: string;
      breadcrumbs: string[];
      completed: boolean;
    },
    input?: any,
  ) {
    const { data } = await apiClient.post('/run/preview/next', { flow, ...run, input });
    return data;
  },
};
